<style scoped>
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-250px * 7));
  }
}
.slider {
  background: white;
  margin: auto;
  overflow: hidden;
  position: relative;
}
.slider::before,
.slider::after {
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  content: "";
  position: absolute;
  width: 200px;
  z-index: 2;
}
.slider::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}
.slider::before {
  left: 0;
  top: 0;
}
.slider .slide-track {
  animation: scroll 40s linear infinite;
  display: flex;
  width: calc(250px * 14);
}
.slider .slide {
  margin-top:-50px;
  height: 200px;
}
</style>
<template>
  <div class="bg-white border-t border-gray-200">
    <div class="slider">
      <p class="text-center uppercase font-bold text-gray-700 mb-0">Te protegemos junto a </p>
      <div class="slide-track">
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
        <div class="slide col-span-1 flex justify-center">
          <img class="h-auto" src="@/assets/images/logo_AXAKERALTY.svg" alt="Tuple" />
        </div>
      </div>
    </div>
  </div>
</template>